const DEVICE_ID_KEY = "prontopsy_device_id";

function createDeviceId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `device_${crypto.randomUUID()}`;
  }
  return `device_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function getDeviceId() {
  try {
    if (typeof window === "undefined" || !window.localStorage) {
      return createDeviceId();
    }
    let deviceId = window.localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
      deviceId = createDeviceId();
      window.localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  } catch (_) {
    return createDeviceId();
  }
}

